import { AlpsAcatDetailV2WebDto } from '../../../../api/types'
import {
  TRANSFER_TYPE_FAIL_REVERSAL_BROKER_TO_BROKER_ONLY,
  TRANSFER_TYPE_FULL_TRANSFER,
  TRANSFER_TYPE_MUTUAL_FUND_CLEANUP,
  TRANSFER_TYPE_PARTIAL_TRANSFER_DELIVERER,
  TRANSFER_TYPE_PARTIAL_TRANSFER_RECEIVER,
  TRANSFER_TYPE_POSITION_TRANSFER_FUND_FIRM_TO_MUTUAL_FUND_COMPANY_ONLY,
  TRANSFER_TYPE_RECLAIM,
  TRANSFER_TYPE_RESIDUAL_CREDIT,
  TRANSFER_TYPE_UNDEFINED,
  PROCESSING_DIRECTION_INTERNAL,
  PROCESSING_DIRECTION_INCOMING,
  PROCESSING_DIRECTION_JOINING,
  PROCESSING_DIRECTION_LEAVING,
  PROCESSING_DIRECTION_OUTGOING,
  NSCC_STATUS_REQUEST,
  NSCC_STATUS_REQUEST_ADJUST,
  NSCC_STATUS_REQUEST_ADJUST_PAST,
  NSCC_STATUS_REQUEST_PAST,
  NSCC_STATUS_REQUEST_REJECT,
  NSCC_STATUS_REVIEW,
  NSCC_STATUS_REVIEW_ADJUST_DELIVERER,
  NSCC_STATUS_REVIEW_ERROR,
  NSCC_STATUS_REVIEW_ACCELERATE,
  NSCC_STATUS_REVIEW_ADJUST_RECEIVER_ACCELERATE,
  NSCC_STATUS_SETTLE_PREP,
  NSCC_STATUS_SETTLE_CLOSE,
  NSCC_STATUS_CLOSE_PURGE,
  NSCC_STATUS_REQUEST_500,
  NSCC_STATUS_MEMO_PURGE_PARTIAL_TRANSFER_REQUEST_RECEIVER,
  NSCC_STATUS_PARTIAL_REQUEST,
  NSCC_STATUS_REJECT,
  NSCC_STATUS_SYSTEM_PURGE,
  NSCC_STATUS_UNDEFINED,
  ALPS_RECOMMENDED_ACTION_NONE,
  ALPS_RECOMMENDED_ACTION_ACCEPT_ASSETS,
  ALPS_RECOMMENDED_ACTION_ATTACH_ASSETS,
  ALPS_RECOMMENDED_ACTION_REJECT,
  ALPS_RECOMMENDED_ACTION_RESUBMIT,
  ALPS_RECOMMENDED_ACTION_INITIATE,
  ALPS_RECOMMENDED_ACTION_ADD_ASSET,
  ALPS_RECOMMENDED_ACTION_DELETE_ASSET,
  ALPS_RECOMMENDED_ACTION_ADJUST_ASSET,
  ALPS_RECOMMENDED_ACTION_PURGE,
  ALPS_RECOMMENDED_ACTION_REJECT_SSN_TAX_ID_MISMATCH,
  ALPS_RECOMMENDED_ACTION_REJECT_ACCOUNT_TITLE_MISMATCH,
  ALPS_RECOMMENDED_ACTION_REJECT_DOCUMENTATION_NEEDED,
  ALPS_RECOMMENDED_ACTION_REJECT_ACCOUNT_FLAT,
  ALPS_RECOMMENDED_ACTION_REJECT_INVALID_ACCOUNT_NUMBER,
  ALPS_RECOMMENDED_ACTION_REJECT_DUPLICATE,
  ALPS_RECOMMENDED_ACTION_REJECT_ACCOUNT_IN_DISTRIBUTION_OR_TRANSFER,
  ALPS_RECOMMENDED_ACTION_REJECT_CLIENT_RESCINDED,
  ALPS_RECOMMENDED_ACTION_REJECT_MISSING_AUTHORIZATION_SIGNATURE,
  ALPS_RECOMMENDED_ACTION_REJECT_CREDIT_POLICY_VIOLATION,
  ALPS_RECOMMENDED_ACTION_REJECT_CREDIT_POLICY_VIOLATION_HARD,
  ALPS_RECOMMENDED_ACTION_REJECT_UNRECOGNIZED_FOR_RESIDUAL_CREDIT_BALANCE,
  ALPS_RECOMMENDED_ACTION_REJECT_PARTIAL_TRANSFER_DELIVERER_INITIATED_REJECT,
  ALPS_RECOMMENDED_ACTION_REJECT_FAIL_REVERSAL_REJECT,
  ALPS_RECOMMENDED_ACTION_REJECT_RECLAIM_REJECT,
  ALPS_RECOMMENDED_ACTION_REJECT_MUTUAL_FUND_CLEANUP_REJECT,
  ALPS_RECOMMENDED_ACTION_ACCEPT,
  ALPS_RECOMMENDED_ACTION_ACCELERATE,
  ALPS_RECOMMENDED_ACTION_WAITING_ON_CONTRA_PARTY,
  ALPS_RECOMMENDED_ACTION_WAITING_ON_NSCC,
  ALPS_RECOMMENDED_ACTION_SUBMIT_FR,
  ALPS_STATUS_INITIAL,
  ALPS_STATUS_CONTRA_PARTY,
  ALPS_STATUS_NSCC,
  ALPS_STATUS_FINISHED,
  ALPS_STATUS_REQUEST_ALPS_APPROVAL,
  ALPS_STATUS_REQUEST_MARGINS_APPROVAL,
  ALPS_STATUS_REVIEW_ERROR,
  ALPS_STATUS_SETTLING,
  ALPS_STATUS_CREATE_SWEEPING_REQUEST,
  ALPS_STATUS_INVALID_LEGACY,
  ALPS_STATUS_CREATE_REQUEST,
  ALPS_STATUS_REQUEST_ERROR,
  ALPS_STATUS_REVIEW_ALPS_APPROVAL,
  ALPS_STATUS_REVIEW_MARGIN_APPROVAL,
  ALPS_STATUS_REQUEST_CONTRA_PARTY_APPROVAL,
  ALPS_STATUS_ERROR,
  ALPS_STATUS_TRANSFER_COMPLETE,
  ALPS_STATUS_REGISTERING_FUNDS,
  REJECT_REASON_NONE,
  REJECT_REASON_SSN_TAX_ID,
  REJECT_REASON_ACCOUNT_TITLE,
  REJECT_REASON_DOCUMENTATION_MISSING,
  REJECT_REASON_ACCOUNT_FLAT,
  REJECT_REASON_ACCOUNT_NUMBER,
  REJECT_REASON_DUPLICATE,
  REJECT_REASON_IN_DISTRIBUTION_OR_TRANSFER,
  REJECT_REASON_CLIENT_RESCINDED,
  REJECT_REASON_AUTHORIZATION_SIGNATURE_MISSING,
  REJECT_REASON_POSITION_TRANSFER_FUND,
  REJECT_REASON_CREDIT_POLICY_VIOLATION,
  REJECT_REASON_RCR_REJECT,
  REJECT_REASON_PTD_REJECT,
  REJECT_REASON_FRV_REJECT,
  REJECT_REASON_RCL_REJECT,
  REJECT_REASON_MFC_REJECT,
  REJECT_REASON_PTF_REJECT,
  REJECT_REASON_NSCC_REJECT,
  ACAT_RESOLUTIONS_REJECT_REASON_DOCUMENTATION_NEEDED,
  ACAT_RESOLUTIONS_REJECT_REASON_CLIENT_RESCINDED,
  ACAT_RESOLUTIONS_REJECT_REASON_PARTIAL_TRANSFER_DELIVERER_INITIATED_REJECT,
  ACAT_RESOLUTIONS_REJECT_REASON_MISSING_AUTHORIZATION_SIGNATURE,
  ACAT_RESOLUTIONS_REJECT_REASON_CREDIT_POLICY_VIOLATED,
} from './constants'

interface stringObject {
  [key: string]: string
}

const transferTypesMessages: stringObject = {
  [TRANSFER_TYPE_FAIL_REVERSAL_BROKER_TO_BROKER_ONLY]:
    'Fail Reversal (broker to broker only)',
  [TRANSFER_TYPE_FULL_TRANSFER]: 'Full Transfer',
  [TRANSFER_TYPE_MUTUAL_FUND_CLEANUP]: 'Mutual Fund Cleanup',
  [TRANSFER_TYPE_PARTIAL_TRANSFER_DELIVERER]: 'Partial Transfer Deliverer',
  [TRANSFER_TYPE_PARTIAL_TRANSFER_RECEIVER]:
    'Partial Transfer Request (Receiver)',
  [TRANSFER_TYPE_POSITION_TRANSFER_FUND_FIRM_TO_MUTUAL_FUND_COMPANY_ONLY]:
    'Position Transfer Fund (Firm to Mutual Fund Company Only)',
  [TRANSFER_TYPE_RECLAIM]: 'Reclaim',
  [TRANSFER_TYPE_RESIDUAL_CREDIT]: 'Residual Credit',
  [TRANSFER_TYPE_UNDEFINED]: 'Undefined',
}

export const getTransferTypeMessage = (transferType: string): string => {
  return transferTypesMessages[transferType]
}

const directionMessages: stringObject = {
  [PROCESSING_DIRECTION_INTERNAL]: 'Internal',
  [PROCESSING_DIRECTION_INCOMING]: 'Incoming',
  [PROCESSING_DIRECTION_JOINING]: 'Incoming',
  [PROCESSING_DIRECTION_LEAVING]: 'Outgoing',
  [PROCESSING_DIRECTION_OUTGOING]: 'Outgoing',
}

export const getDirectionMessage = (direction: string): string => {
  return directionMessages[direction]
}

export const getCorrespondentName = (
  transfer: AlpsAcatDetailV2WebDto
): string | null => {
  switch (transfer.direction) {
    case PROCESSING_DIRECTION_INTERNAL:
    case PROCESSING_DIRECTION_JOINING:
      return transfer.receiver.correspondentName
    case PROCESSING_DIRECTION_LEAVING:
      return transfer.deliverer.correspondentName
    default:
      return null
  }
}

const nsccMessages: stringObject = {
  [NSCC_STATUS_REQUEST]: 'Request',
  [NSCC_STATUS_REQUEST_ADJUST]: 'Request Adjust',
  [NSCC_STATUS_REQUEST_ADJUST_PAST]: 'Request Adjust Past',
  [NSCC_STATUS_REQUEST_PAST]: 'Request Past',
  [NSCC_STATUS_REQUEST_REJECT]: 'Request Reject',
  [NSCC_STATUS_REVIEW]: 'Review',
  [NSCC_STATUS_REVIEW_ADJUST_DELIVERER]: 'Review Adjust Deliverer',
  [NSCC_STATUS_REVIEW_ERROR]: 'Review Error',
  [NSCC_STATUS_REVIEW_ACCELERATE]: 'Review Accelerate',
  [NSCC_STATUS_REVIEW_ADJUST_RECEIVER_ACCELERATE]:
    'Review Adjust Receiver Accelerate',
  [NSCC_STATUS_SETTLE_PREP]: 'Settle Prep',
  [NSCC_STATUS_SETTLE_CLOSE]: 'Settle Close',
  [NSCC_STATUS_CLOSE_PURGE]: 'Close Purge',
  [NSCC_STATUS_REQUEST_500]: 'Request 500',
  [NSCC_STATUS_MEMO_PURGE_PARTIAL_TRANSFER_REQUEST_RECEIVER]:
    'Memo Purge-Partial Transfer Request (Receiver)',
  [NSCC_STATUS_PARTIAL_REQUEST]: 'Partial Request',
  [NSCC_STATUS_REJECT]: 'Reject',
  [NSCC_STATUS_SYSTEM_PURGE]: 'System Purge',
  [NSCC_STATUS_UNDEFINED]: 'Undefined',
}

export const getNsccState = (status: string) => {
  return nsccMessages[status]
}

const alpsRecommendedActions: stringObject = {
  [ALPS_RECOMMENDED_ACTION_NONE]: 'None',
  [ALPS_RECOMMENDED_ACTION_ACCEPT_ASSETS]: 'Accept Assets',
  [ALPS_RECOMMENDED_ACTION_ATTACH_ASSETS]: 'Attach Assets',
  [ALPS_RECOMMENDED_ACTION_REJECT]: 'Reject',
  [ALPS_RECOMMENDED_ACTION_RESUBMIT]: 'Resubmit',
  [ALPS_RECOMMENDED_ACTION_INITIATE]: 'Initiate',
  [ALPS_RECOMMENDED_ACTION_ADD_ASSET]: 'Add Asset',
  [ALPS_RECOMMENDED_ACTION_DELETE_ASSET]: 'Delete Asset',
  [ALPS_RECOMMENDED_ACTION_ADJUST_ASSET]: 'Adjust Asset',
  [ALPS_RECOMMENDED_ACTION_PURGE]: 'Purge',
  [ALPS_RECOMMENDED_ACTION_REJECT_SSN_TAX_ID_MISMATCH]:
    'Reject - SSN Tax ID Mismatch',
  [ALPS_RECOMMENDED_ACTION_REJECT_ACCOUNT_TITLE_MISMATCH]:
    'Reject - Account Title Mismatch',
  [ALPS_RECOMMENDED_ACTION_REJECT_DOCUMENTATION_NEEDED]:
    'Reject - Documentation Needed',
  [ALPS_RECOMMENDED_ACTION_REJECT_ACCOUNT_FLAT]: 'Reject - Account Flat',
  [ALPS_RECOMMENDED_ACTION_REJECT_INVALID_ACCOUNT_NUMBER]:
    'Reject - Invalid Account Number',
  [ALPS_RECOMMENDED_ACTION_REJECT_DUPLICATE]: 'Reject - Duplicate',
  [ALPS_RECOMMENDED_ACTION_REJECT_ACCOUNT_IN_DISTRIBUTION_OR_TRANSFER]:
    'Reject - Account in Distribution or Transfer',
  [ALPS_RECOMMENDED_ACTION_REJECT_CLIENT_RESCINDED]:
    'Reject - Client Rescinded',
  [ALPS_RECOMMENDED_ACTION_REJECT_MISSING_AUTHORIZATION_SIGNATURE]:
    'Reject - Missing Authorization Signature',
  [ALPS_RECOMMENDED_ACTION_REJECT_CREDIT_POLICY_VIOLATION]:
    'Reject - Credit Policy Violation',
  [ALPS_RECOMMENDED_ACTION_REJECT_CREDIT_POLICY_VIOLATION_HARD]:
    'Reject - Credit Policy Violation Hard',
  [ALPS_RECOMMENDED_ACTION_REJECT_UNRECOGNIZED_FOR_RESIDUAL_CREDIT_BALANCE]:
    'Reject - Unrecognized for Residual Credit Balance',
  [ALPS_RECOMMENDED_ACTION_REJECT_PARTIAL_TRANSFER_DELIVERER_INITIATED_REJECT]:
    'Reject - Partial Transfer Deliverer Initiated Reject',
  [ALPS_RECOMMENDED_ACTION_REJECT_FAIL_REVERSAL_REJECT]:
    'Reject - Fail Reversal Reject',
  [ALPS_RECOMMENDED_ACTION_REJECT_RECLAIM_REJECT]: 'Reject - Reclaim Reject',
  [ALPS_RECOMMENDED_ACTION_REJECT_MUTUAL_FUND_CLEANUP_REJECT]:
    'Reject - Mutual Fund Cleanup Reject',
  [ALPS_RECOMMENDED_ACTION_ACCEPT]: 'Accept',
  [ALPS_RECOMMENDED_ACTION_ACCELERATE]: 'Accelerate',
  [ALPS_RECOMMENDED_ACTION_WAITING_ON_CONTRA_PARTY]: 'Waiting on ContraParty',
  [ALPS_RECOMMENDED_ACTION_WAITING_ON_NSCC]: 'Waiting on NSCC',
  [ALPS_RECOMMENDED_ACTION_SUBMIT_FR]: 'Submit FR',
}

export const getRecommendedAction = (
  alpsRecommendedAction: string | null
): string | null => {
  if (!alpsRecommendedAction) return null
  return alpsRecommendedActions[alpsRecommendedAction]
}

const alpsStatus: stringObject = {
  [ALPS_STATUS_INITIAL]: 'Initial',
  [ALPS_STATUS_CONTRA_PARTY]: 'ContraParty',
  [ALPS_STATUS_NSCC]: 'Nscc',
  [ALPS_STATUS_FINISHED]: 'Finished',
  [ALPS_STATUS_REQUEST_ALPS_APPROVAL]: 'Request Alps Approval',
  [ALPS_STATUS_REQUEST_MARGINS_APPROVAL]: 'Request Margins Approval',
  [ALPS_STATUS_REVIEW_ERROR]: 'Review Error',
  [ALPS_STATUS_SETTLING]: 'Settling',
  [ALPS_STATUS_CREATE_SWEEPING_REQUEST]: 'Create Sweeping Request',
  [ALPS_STATUS_INVALID_LEGACY]: 'Invalid Legacy',
  [ALPS_STATUS_CREATE_REQUEST]: 'Create Request',
  [ALPS_STATUS_REQUEST_ERROR]: 'Request Error',
  [ALPS_STATUS_REVIEW_ALPS_APPROVAL]: 'Review Alps Approval',
  [ALPS_STATUS_REVIEW_MARGIN_APPROVAL]: 'Review Margin Approval',
  [ALPS_STATUS_REQUEST_CONTRA_PARTY_APPROVAL]: 'Contra Party Approval',
  [ALPS_STATUS_ERROR]: 'Error',
  [ALPS_STATUS_TRANSFER_COMPLETE]: 'Complete',
  [ALPS_STATUS_REGISTERING_FUNDS]: 'Registering Funds',
}

export const getAlpsState = (status: string) => {
  return alpsStatus[status]
}

const rejectReason: stringObject = {
  [REJECT_REASON_NONE]: 'None',
  [REJECT_REASON_SSN_TAX_ID]: 'SSN Tax id',
  [REJECT_REASON_ACCOUNT_TITLE]: 'Account Title',
  [REJECT_REASON_DOCUMENTATION_MISSING]: 'Documentation Missing',
  [REJECT_REASON_ACCOUNT_FLAT]: 'Account Flat',
  [REJECT_REASON_ACCOUNT_NUMBER]: 'Account Number',
  [REJECT_REASON_DUPLICATE]: 'Duplicate',
  [REJECT_REASON_IN_DISTRIBUTION_OR_TRANSFER]: 'In Distribution or Transfer',
  [REJECT_REASON_CLIENT_RESCINDED]: 'Client Rescinded',
  [REJECT_REASON_AUTHORIZATION_SIGNATURE_MISSING]:
    'Authorization Signature Missing',
  [REJECT_REASON_POSITION_TRANSFER_FUND]: 'Position Transfer Fund',
  [REJECT_REASON_CREDIT_POLICY_VIOLATION]: 'Credit Policy Violation',
  [REJECT_REASON_RCR_REJECT]: 'RCR Reject',
  [REJECT_REASON_PTD_REJECT]: 'PTD Reject',
  [REJECT_REASON_FRV_REJECT]: 'FRV Reject',
  [REJECT_REASON_RCL_REJECT]: 'RCL Reject',
  [REJECT_REASON_MFC_REJECT]: 'MFC Reject',
  [REJECT_REASON_PTF_REJECT]: 'PTF Reject',
  [REJECT_REASON_NSCC_REJECT]: 'NSCC Reject',
  [ACAT_RESOLUTIONS_REJECT_REASON_DOCUMENTATION_NEEDED]:
    'Documentation Missing',
  [ACAT_RESOLUTIONS_REJECT_REASON_CLIENT_RESCINDED]: 'Client Rescinded',
  [ACAT_RESOLUTIONS_REJECT_REASON_PARTIAL_TRANSFER_DELIVERER_INITIATED_REJECT]:
    'Partial Transfer Deliverer Initiated Reject',
  [ACAT_RESOLUTIONS_REJECT_REASON_MISSING_AUTHORIZATION_SIGNATURE]:
    'Authorization Signature Missing',
  [ACAT_RESOLUTIONS_REJECT_REASON_CREDIT_POLICY_VIOLATED]:
    'Credit Policy Violation',
}

export const getRejectReason = (reason: string) => {
  return rejectReason[reason]
}
